<template>
<div class="flex w-full vx-row no-gutter justify-center">
  <div class="vx-col sm:w-full md:w-full lg:w-3/5">
    <vx-card class="study-card"> 
    <vs-list>
      <vs-list-header title="원어민 발음으로 빠르게 읽어보세요." icon-pack="feather" icon="icon-info"></vs-list-header>
      <!-- <vs-list-item class="msg-grp-container">
        <vs-chip color="warning mr-0">{{ contentIndex + 1 }} / {{contentsLen}}</vs-chip>
      </vs-list-item> -->
    </vs-list>

        <div class="vx-row mb-2">
          <div class="text-center mb-3 mt-3">
          </div>
          <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/4 w-1/2">
            <vx-card style="height: 140px">
              <div class="vx-row">
                <div class="vx-col w-full flex items-center justify-center">
                  <vs-chip color="primary">원어민</vs-chip>
                </div> 
              </div>
              <time-card class="mb-2" ref="timeCard1"></time-card>
            </vx-card>
          </div>
          <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/4 w-1/2">
            <vx-card style="height: 140px">
              <div class="vx-row">
                <div class="vx-col w-full flex items-center justify-center">
                  <vs-chip color="success">내기록1</vs-chip>
                </div> 
              </div>
              <div class="vx-row">
                <div class="vx-col w-full flex items-center justify-center">
                  <time-card class="mb-2" ref="timeCard2"></time-card>
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col w-full flex items-center justify-center">  
                  <vue-record-audio v-show="studyIndex === 0 && !recordingStatus[0].recording" class="record-audio" :mode="recordMode.audio" @result="onResult" @start="onRecordStart"/>
                  <div v-show="recordingStatus[0].recording">
                    <a href="#" @click="onListen(0)" >듣기</a> | <a href="#" @click="onSend(0)">전송</a>
                  </div>
                </div>  
              </div>  
            </vx-card>
          </div>

          <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/4 w-1/2">
            <vx-card style="height: 140px">
              <div class="vx-row">
                <div class="vx-col w-full flex items-center justify-center">
                  <vs-chip color="success">내기록2</vs-chip>
                </div> 
              </div>
              <div class="vx-row">
                <div class="vx-col w-full flex items-center justify-center">
                  <time-card class="mb-2" ref="timeCard3"></time-card>
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col w-full flex items-center justify-center">  
                  <vue-record-audio v-show="studyIndex === 1 && !recordingStatus[1].recording" class="record-audio" :mode="recordMode.audio" @result="onResult" @start="onRecordStart"/>
                  <div v-show="recordingStatus[1].recording">
                    <a href="#" @click="onListen(1)" >듣기</a> | <a href="#" @click="onSend(1)">전송</a>
                  </div>
                </div>  
              </div>  
            </vx-card>
          </div>

          <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/4 w-1/2">
            <vx-card style="height: 140px">
              <div class="vx-row">
                <div class="vx-col w-full flex items-center justify-center">
                  <vs-chip color="success">내기록3</vs-chip>
                </div> 
              </div>
              <div class="vx-row">
                <div class="vx-col w-full flex items-center justify-center">
                  <time-card class="mb-2" ref="timeCard4"></time-card>
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col w-full flex items-center justify-center">  
                  <vue-record-audio v-show="studyIndex === 2 && !recordingStatus[2].recording" class="record-audio" :mode="recordMode.audio" @result="onResult" @start="onRecordStart"/>
                  <div v-show="recordingStatus[2].recording">
                    <a href="#" @click="onListen(2)" >듣기</a> | <a href="#" @click="onSend(2)">전송</a>
                  </div>
                </div>  
              </div>  
            </vx-card>
          </div>
        </div>

      <vs-alert v-show="!audioFinished" color="danger" class="mt-3 mb-3 text-center" >
        원어민의 발음을 들어 보세요.
      </vs-alert>

      <div class="text-center mt-3">
        <audio ref="userAudioPlayer" v-show="isUserAudioPlaying"
            controls
            v-on:ended="userAudioFinish"
            controlsList="nodownload">Your browser does not support the <code>audio</code> element.
        </audio>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full">
          <vx-card>
            <perfect-scrollbar style="height:220px">
              <vs-list>
                <vs-list-item v-for="(content, index) in contentList" 
                  :class="contentIndex===index ? 'text-primary' : ''" 
                  :key="index"
                  :title="content.sentence">
                </vs-list-item>
              </vs-list>
            </perfect-scrollbar>  
          </vx-card>  
        </div>
      </div>

      <div class="text-center">
        <audio ref="audioPlayer" 
            controls
            v-on:ended="audioFinish"
            hidden
            controlsList="nodownload">Your browser does not support the <code>audio</code> element.
        </audio>
      </div>
    </vx-card>
    <top-button-bar @onReload="onReload" @onNext="onNext" @onFinish="onFinish" @onHint="onHint" ></top-button-bar>
  </div>  
</div>
</template>

<script>
import StudyMenuMixin from './StudyMenuMixin'
import TopButtonBar      from './TopButtonBar.vue'
import TimeCard      from './TimeCard.vue'
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'

export default {
  mixins: [StudyMenuMixin],
  components: {
    TopButtonBar,
    TimeCard,
    PerfectScrollbar
  },
  data () {
    return {
      contentList: [],
      contentsLen: 0,
      contentIndex: 0,
      recordMode: {
        audio: 'press',
        video: 'press'
      },
      audioFinished: false,
      studyFinished: false,
      studyIndex: -1,
      timeCardList: [],
      recordingStatus: [
        {recording: false,  result: null}, 
        {recording: false, result: null}, 
        {recording: false, result: null}
      ],
      isUserAudioPlaying: false,
      selectedAudioIndex: -1
    }
  },
  computed: {
    content () {
      return this.contentList[this.contentIndex]
    },
    audioPlayer () {
      return this.$refs.audioPlayer
    },
    userAudioPlayer () {
      return this.$refs.userAudioPlayer
    }
  },
  watch: {
    sourceContent () {
      this.contentList = []
      this.parseContent()
      this.onReload()
    }
  },
  methods: {
    onListen (index) {
      this.isUserAudioPlaying = true
      this.userAudioPlayer.src = this.recordingStatus[index].result
      this.userAudioPlayer.play()
    },
    onSend (index) {

      if (!this.studyFinished) {
        this.$vs.dialog({
          color: 'danger',
          title: '알림',
          text: '녹음을 3회 완료하고 전송 버튼을 누르시기 바랍니다.'
        })
      } else {
        
        //console.log(this.recordingStatus[index].result)
        this.selectedAudioIndex = index

        this.$vs.dialog({
          type: 'confirm',
          color: 'primary',
          title: '서버전송',
          text: '선택한 녹음을 서버로 전송하시겠습니까?',
          accept: this.sendAudio
        })
      }
    },
    sendAudio () {
      //console.log(this.selectedAudioIndex)
      this.onComplete()
    },
    onRecordStart () {
      this.timeCardList[this.studyIndex].start()  
    },
    onReload () {
      this.contentIndex = 0
      this.studyIndex = -1
      this.audioFinished = false
      this.sudyFinished = false
      this.isUserAudioPlaying = false
      this.audioPlayer.pause()
      this.userAudioPlayer.pause()
      this.$refs.timeCard1.reset()
      this.$refs.timeCard2.reset()
      this.$refs.timeCard3.reset()
      this.$refs.timeCard4.reset()
      this.recordingStatus = [
        {recording: false,  result: null}, 
        {recording: false, result: null}, 
        {recording: false, result: null}
      ]
      this.startAlert()
    },
    onStart () {
      this.$refs.timeCard1.start()
      this.audioPlay()
    },
    userAudioFinish () {
      this.isUserAudioPlaying = false
    },
    audioFinish () {

      if (this.contentIndex >= this.contentsLen - 1) {
        this.audioFinished = true
        this.studyIndex = 0
        this.$refs.timeCard1.stop()
        
        this.$vs.dialog({
          color: 'primary',
          title: '녹음하기',
          text: '녹음 버튼을 1회 누르고 녹음을 시작합니다. 녹음이 끝나면 녹음 버튼을 한번 더 누르세요.'
        })

      } else {
        this.contentIndex++
        this.audioPlay()
      }
    },
    audioPlay () {
      this.audioPlayer.src = this.content.audio
      this.audioPlayer.play()
    },
    onResult (data) {
      this.timeCardList[this.studyIndex].stop() 
      this.recordingStatus[this.studyIndex].result = window.URL.createObjectURL(data)
      this.recordingStatus[this.studyIndex].recording = true

      if (this.studyIndex < 2) {
        this.studyIndex++
      } else {
        this.studyFinished = true
        this.$vs.dialog({
          color: 'primary',
          title: '알림',
          text: '녹음된 발음을 들어보고 하나를 골라 [전송] 버튼을 눌러 주세요. [전송] 버튼을 누르면 학습이 완료됩니다.'
        })
      }
    },
    startAlert () {
      this.startStudyDlg('원어민 발음으로 빠르게 읽어보세요.')
    },
    acceptAlert () {
      this.onStart()
    },
    parseContent () {
      const contentJson = JSON.parse(this.sourceContent.contentBody)
      for (let i = 0; i < contentJson.sentence.length; i++) {
        const content = {
          sentence: contentJson.sentence[i],
          translation: contentJson.translation[i],
          audio: this.$buildAudioPath(this.sourceContent.contentCode, i + 1)
        } 
        this.contentList.push(content)
      }
      this.contentsLen = this.contentList.length
    }
  },
  created () {

    this.parseContent()
    this.startAlert()

  },
  mounted () {
    this.timeCardList.push(this.$refs.timeCard2)
    this.timeCardList.push(this.$refs.timeCard3)
    this.timeCardList.push(this.$refs.timeCard4)
  }
}

</script>

<style src="vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css"/>

<style scoped>
.record-audio {
  width:40px;
  height:40px
}
</style>